// components/PublishWarningModal.jsx
import { MdWarningAmber } from 'react-icons/md';

export const PublishWarningModal = ({ onClose }) => {
  return (
    <div className='custom-popup warning-popup'>
      <div className='popup-content'>
        <div className='popup-head text-center'>
          <h4 className='popup-title d-flex justify-content-center align-items-center gap-2'>
            <MdWarningAmber className='warning-icon' />
            Publish Chatbot Required
          </h4>
        </div>

        <hr className='my-3' />

        <div className='popup-body text-center'>
          <p className='popup-message'>
            Just before you test me, first click the <span className='fw-bold'>Publish Chatbot</span> button at the top right of the page.
          </p>
        </div>

        <div className='popup-footer text-center mt-4'>
          <button className='btn btn-warning px-4 fw-semibold' onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
